import * as Types from '@/store/types'
import { STAT_EVENT, THIRD_API } from '@/global/config'
import http from '@/plugins/http'

const isProd = process.env.VUE_APP_ENV === 'release'

class StatObserver {
  constructor({ key, params = {}, pathName = null }) {
    this.currentPath = pathName
    this.key = key
    this.params = { ...STAT_EVENT[key], ...params }
    if (this.currentPath && !this.params.g) {
      this.params.g = this.currentPath
    }
    this.timestamp = +new Date()
  }

  update(opt) {
    this.params.u = opt.uid
    const uid = this.params.u
    // 在这个方法里面，判断需要发送到哪些平台
    // 新增过滤逻辑 如果 uid为空 或者 ua为爬虫 不发送
    if (
      !uid ||
      uid === 'undefined' ||
      uid === 'null' ||
      uid === 'NULL' ||
      /Baiduspider|bingbot|Sosospider|Sogou web spider|Sogou inst spider|Googlebot|360Spider|PhantomJS/i.test(
        window.navigator.userAgent
      )
    ) {
      return false
    } else {
      return this.mergeParams()
    }
  }

  mergeParams() {
    const { u, a } = this.params

    let attribute = this.getAttribute()
    const href = window.location.href
    const p = encodeURIComponent(href)

    return {
      _pk: '300003',
      _uk: 'Marketing_1.0.0',
      _src: 'web',
      _v: '1.0',
      _rk: this.guid(),
      _cp: {
        device_id: this.guid()
      },
      _ep: [
        {
          timestamp: this.timestamp,
          et: 'custom',
          method: a,
          ek: `mkt_${a}`,
          suid: u,
          src: p,
          attribute
        }
      ]
    }
  }

  getAttribute() {
    const fr = document.cookie
      .split(';')
      .map(item => item.trim())
      .reduce(
        (p, c) => (c.indexOf('fr=') === 0 ? c.substring(3, c.length) : p),
        ''
      )
    const referrer = window.refer || ''
    const r = encodeURIComponent(referrer)
    return {
      ua: `${(window.screen && window.screen.width) || 0}x${
        (window.screen && window.screen.height) || 0
      }|${window.navigator.userAgent}`,
      dv: 'pc',
      ust: '1',
      sn: fr,
      r,
      module: '',
      ...this.params
    }
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    )
  }
}

export default {
  state() {
    return {
      observers: [],
      uid: null
    }
  },
  mutations: {
    [Types.UPDATE_STAT_INFO](state, uid) {
      state.uid = uid
    },
    [Types.ADD_OBSERVER](state, observer) {
      state.observers = [...state.observers, observer]
    },
    [Types.CLEAR_OBSERVER](state) {
      state.observers = []
    }
  },
  actions: {
    [Types.SET_STAT]({ commit }, uid) {
      if (uid) {
        commit(Types.UPDATE_STAT_INFO, uid)
        commit(Types.UPDATE_OBSERVER)
      }
    },
    [Types.ADD_STAT]({ state, commit, dispatch }, { key, params, pathName }) {
      commit(Types.ADD_OBSERVER, new StatObserver({ key, params, pathName }))
      if (state.uid) {
        dispatch(Types.UPDATE_OBSERVER)
      }
    },
    [Types.UPDATE_OBSERVER]({ state, commit, dispatch }) {
      const { observers, uid } = state
      if (observers.length > 0) {
        for (let i = 0; i < observers.length; i++) {
          let ob = state.observers[i]
          const params = ob.update({ uid })
          if (params) {
            dispatch(Types.DO_STAT, params)
          }
        }
        commit(Types.CLEAR_OBSERVER)
      }
    },
    [Types.DO_STAT](context, data) {
      let url = isProd ? THIRD_API.simaStat.link : THIRD_API.simaStat.mock
      http.post(url, { data })
    }
  },
  namespaced: true
}
